/** Display helpers for the tool surfaces; all times are shown in the record's own timezone. */
export const browserTimezone = () => Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC";
export function formatWhen(at: string | null | undefined, timezone: string, allDay = false): string {
  if (!at) return "No due date";
  try {
    return new Intl.DateTimeFormat("en-GB", { timeZone: timezone, dateStyle: "medium", ...(allDay ? {} : { timeStyle: "short" }) }).format(new Date(at));
  } catch {
    return new Date(at).toISOString();
  }
}
export function formatDay(at: string, timezone: string): string {
  try {
    return new Intl.DateTimeFormat("en-GB", { timeZone: timezone, weekday: "long", day: "numeric", month: "long" }).format(new Date(at));
  } catch {
    return at.slice(0, 10);
  }
}
/** A `datetime-local` value (the wall time in `timezone`) for an ISO instant, and back. */
export function toLocalInput(at: string | null | undefined, timezone: string): string {
  if (!at) return "";
  try {
    const parts = Object.fromEntries(new Intl.DateTimeFormat("en-GB", { timeZone: timezone, hourCycle: "h23", year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit" }).formatToParts(new Date(at)).filter((p) => p.type !== "literal").map((p) => [p.type, p.value]));
    return `${parts.year}-${parts.month}-${parts.day}T${parts.hour === "24" ? "00" : parts.hour}:${parts.minute}`;
  } catch {
    return "";
  }
}
export function fromLocalInput(value: string, timezone: string): string | undefined {
  if (!value) return undefined;
  const [date, time] = value.split("T"), [y, m, d] = date.split("-").map(Number), [hh, mm] = time.split(":").map(Number);
  let guess = Date.UTC(y, m - 1, d, hh, mm);
  for (let i = 0; i < 2; i++) {
    const back = toLocalInput(new Date(guess).toISOString(), timezone);
    const [bd, bt] = back.split("T"), [by, bm, bdd] = bd.split("-").map(Number), [bh, bmin] = bt.split(":").map(Number);
    guess += Date.UTC(y, m - 1, d, hh, mm) - Date.UTC(by, bm - 1, bdd, bh, bmin);
  }
  return new Date(guess).toISOString();
}
export const reminderLabel = (minutes: number) => (minutes === 0 ? "at the time" : minutes % 1440 === 0 ? `${minutes / 1440} day${minutes === 1440 ? "" : "s"} before` : minutes % 60 === 0 ? `${minutes / 60} h before` : `${minutes} min before`);
export const parseReminders = (value: string): number[] =>
  [...new Set(value.split(",").map((s) => s.trim()).filter(Boolean).map(Number).filter((n) => Number.isInteger(n) && n >= 0 && n <= 43200))].slice(0, 5);
